export default __webpack_public_path__ + "static/0186-d8b3cccf45cd7e6e007db2c646a8ccc9.png";